import { Css, Filters, multiFilter } from "@homebound/beam";
import { useState } from "react";
import { useParams } from "react-router";
import { SearchBox } from "src/components";
import {
  useDirectMarginTabQuery,
  type DirectMarginTab_ProjectFragment,
} from "src/routes/projects/budget/components/reports/DirectMarginTab.generated";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";
import { DirectMarginPerProjectTable } from "./DirectMarginPerProjectTable";
import { BudgetMetricsViewType, getFromDate, ViewTypeFilter } from "./utils";
import { DirectMarginOverTimeWidget } from "./widgets/DirectMarginOverTimeWidget";

type FilterOptions = { project?: string[] };

export function DirectMarginTab() {
  const { projectId } = useParams<ProjectParams>();
  const [viewType, setViewType] = useState(BudgetMetricsViewType.ALL_TIME);
  const [search, setSearch] = useState<string | undefined>();
  const [filter, setFilter] = useState<FilterOptions>({});
  const query = useDirectMarginTabQuery({
    variables: {
      projectId,
      filter: { fromDate: getFromDate(viewType), childProject: filter.project },
      snapshotDate: getFromDate(viewType, true)!,
    },
  });

  return queryResult(query, ({ project, projectDirectMarginGraph }) => (
    <div>
      <div css={Css.df.mb2.$}>
        <div css={Css.df.cg1.$}>
          <SearchBox onSearch={setSearch} />
          <div>
            <Filters filterDefs={getFilterDefs(project.sellableProjects)} filter={filter} onChange={setFilter} />
          </div>
        </div>
        <ViewTypeFilter viewType={viewType} setViewType={setViewType} />
      </div>
      <DirectMarginOverTimeWidget data={projectDirectMarginGraph} viewType={viewType} />
      <DirectMarginPerProjectTable
        projects={project.sellableProjects.filter((p) => !filter.project?.nonEmpty || filter.project.includes(p.id))}
        search={search}
      />
    </div>
  ));
}

function getFilterDefs(data: DirectMarginTab_ProjectFragment[]) {
  return {
    project: multiFilter({
      options: data,
      getOptionValue: (p) => p.id,
      getOptionLabel: (p) => p.name,
      label: "Project",
    }),
  };
}
